import { lazy } from "react";

export const customeRoutes = {
  DashBoard: lazy(() => import("../shared-components/Dashboard/dashboard")),
  DocumentsUpload: lazy(() => import("../pages/documentsUpload/container")),
  AllDocuments: lazy(() => import("../pages/alldocuments/containers/AllDocuments.Container")),
  Ballot: lazy(() => import("../pages/ballot/ballotFolderList")),
  LitigationHold: lazy(() => import("../pages/litigationHold/Litigation")),
};
